import { render, staticRenderFns } from "./IconEmailAction.vue?vue&type=template&id=45c1a65a&"
import script from "./IconEmailAction.vue?vue&type=script&lang=ts&"
export * from "./IconEmailAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports